import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const keywordsApi = {
  /**
   * Add a scraper keyword to a topic.
   * Keywords are returned inline with topics — no separate list endpoint.
   * @param {number} userId
   * @param {number} topicId
   * @param {{ keyword: string }} body
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  add: (userId, topicId, body, config) =>
    mod.post(
      `/subscribers/${userId}/topics/${topicId}/keywords/`,
      { topicId, ...body },
      config,
    ),

  /**
   * @param {number} userId
   * @param {number} topicId
   * @param {number} keywordId
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  remove: (userId, topicId, keywordId, config) =>
    mod.delete(
      `/subscribers/${userId}/topics/${topicId}/keywords/${keywordId}`,
      config,
    ),
};
